module.exports = __webpack_public_path__ + "static/8-8becf9b11f5bc4420a1100d0c32db7cb.jpg";